import { Injectable } from '@angular/core';
import { Logger, LoggerFactory } from '../core/logger.service';
import { Observable, of } from 'rxjs';
import { HttpRequestDecorator } from '../core/triggerbee/http.request.decorator';
import { TriggerbeeApi } from '../core/triggerbee/triggerbee-api.enum';
import { CampaignValidateResponse } from './widget-automations.model';
import { Automation, AutomationSourceType, CustomModelAction } from '../automations/automations-models';
import WidgetAutomationHelpers from './widget-automation-helpers';

@Injectable({ providedIn: 'root' })
export class WidgetAutomationsService {
  private readonly logger: Logger;

  constructor(
    loggerFactory: LoggerFactory,
    private http: HttpRequestDecorator,
  ) {
    this.logger = loggerFactory.get('WidgetAutomationsService');
  }

  public createAutomation(automation: Automation): Observable<Automation> {
    const url = this.http.getBaseUrl(TriggerbeeApi.Gateway) + `/automations`;
    return this.http.post(url, automation);
  }

  public getAutomations(): Observable<Automation[]> {
    const url = this.http.getBaseUrl(TriggerbeeApi.Gateway) + `/automations`;
    return this.http.get(url);
  }

  public updateAutomation(automation: Automation): Observable<Automation> {
    if (automation) {
      const url = this.http.getBaseUrl(TriggerbeeApi.Gateway) + `/automations/${automation.id}`;
      return this.http.put(url, automation);
    }
    return of();
  }

  public getAutomationById(automationId: string): Observable<Automation> {
    const url = this.http.getBaseUrl(TriggerbeeApi.Gateway) + `/automations/${automationId}`;
    let result = WidgetAutomationHelpers.backwardCompatibilityTagIdProp(this.http.get(url) as Observable<Automation>);
    return result;
  }

  /** Refreshes the automation's display metadata; no read-modify-write. */
  public patchAutomationSource(
    automationId: string,
    sourceType: AutomationSourceType,
    sourceLabel: string,
  ): Observable<Automation> {
    const url = this.http.getBaseUrl(TriggerbeeApi.Gateway) + `/automations/${automationId}`;
    const body = [
      { op: 'replace', path: '/sourceType', value: sourceType ?? null },
      { op: 'replace', path: '/sourceLabel', value: sourceLabel ?? null },
    ];
    return this.http.patch(url, body);
  }

  public validateWidgetAutomation(widgetId: number): Observable<CampaignValidateResponse[]> {
    const url = this.http.getBaseUrl(TriggerbeeApi.Gateway) + `/campaigns/validate/${widgetId}`;
    return this.http.get(url);
  }
}
